module.exports = __webpack_public_path__ + "img/thumbnail_RedFox_f_melanistic.27e209d2.png";